module.exports = __webpack_public_path__ + "img/NEF_checkbox.39f8eb99.svg";